/** @jsxImportSource ../../i18n */
import React, { useRef } from 'react';
import { cx } from '../../theme/cx';

const SIZES = {
  sm: 'h-8 px-2.5 text-[13px] sm:px-3',
  md: 'h-9 px-3.5 text-sm',
};

export const SegmentedControl = ({ options, value, onChange, ariaLabel, size = 'sm', className, fullWidth = false }) => {
  const refs = useRef([]);
  const onKeyDown = (event, index) => {
    const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[event.key];
    if (!step) return;
    event.preventDefault();
    const next = (index + step + options.length) % options.length;
    refs.current[next]?.focus();
    onChange?.(options[next].value);
  };
  return (
    <div role="radiogroup" aria-label={ariaLabel} className={cx('inline-flex max-w-full gap-0.5 overflow-x-auto rounded-control border border-line bg-surface-1 p-0.5', fullWidth && 'flex w-full', className)}>
      {options.map((option, index) => {
        const active = option.value === value;
        const Icon = option.icon;
        return (
          <button
            key={option.value}
            ref={(el) => { refs.current[index] = el; }}
            type="button"
            role="radio"
            aria-checked={active}
            tabIndex={active ? 0 : -1}
            onClick={() => onChange?.(option.value)}
            onKeyDown={(e) => onKeyDown(e, index)}
            className={cx(
              'inline-flex flex-shrink-0 items-center justify-center gap-1.5 whitespace-nowrap rounded-[8px] font-medium transition-colors duration-150',
              SIZES[size] || SIZES.sm,
              fullWidth && 'flex-1',
              active ? 'bg-gold-500/15 text-gold-300 shadow-[inset_0_0_0_1px_rgb(var(--c-gold-500)/0.3)]' : 'text-fg-muted hover:bg-surface-2 hover:text-fg',
            )}
          >
            {Icon && <Icon size={14} aria-hidden="true" />}
            {option.label}
          </button>
        );
      })}
    </div>
  );
};
